<div class="device-stats-modal">
    <div class="modal-header">
        <div class="header-content">
            <h2 mat-dialog-title>
                <mat-icon>bar_chart</mat-icon>
                <div class="title-text">
                    <span class="main-title">{{'Device Training Statistics'|translate}}</span>
                    <span class="device-name">{{resource.name}}<span *ngIf="resource.serialNumber" class="serial-number"> ({{resource.serialNumber}})</span></span>
                </div>
            </h2>
        </div>
        <button mat-icon-button (click)="onNoClick()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="modal-content">

        <!-- Period Selector -->
        <div class="period-selector">
            <mat-form-field>
                <mat-label>{{'Period'|translate}}</mat-label>
                <mat-select [(ngModel)]="selectedPeriod" (selectionChange)="onPeriodChange()">
                    <mat-option [value]="7">{{'Last 7 days'|translate}}</mat-option>
                    <mat-option [value]="14">{{'Last 14 days'|translate}}</mat-option>
                    <mat-option [value]="30">{{'Last 30 days'|translate}}</mat-option>
                    <mat-option [value]="60">{{'Last 60 days'|translate}}</mat-option>
                    <mat-option [value]="90">{{'Last 90 days'|translate}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Summary Stats -->
        <div class="summary-stats" *ngIf="!loading && !error">
            <div class="stat-card">
                <mat-icon>fitness_center</mat-icon>
                <div class="stat-content">
                    <div class="stat-value">{{totalTrainings}}</div>
                    <div class="stat-label">{{'Total Trainings'|translate}}</div>
                </div>
            </div>
            <div class="stat-card">
                <mat-icon>calendar_today</mat-icon>
                <div class="stat-content">
                    <div class="stat-value">{{(totalTrainings / selectedPeriod).toFixed(1)}}</div>
                    <div class="stat-label">{{'Avg per Day'|translate}}</div>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-container" *ngIf="loading">
            <mat-spinner></mat-spinner>
            <p>{{'Loading statistics...'|translate}}</p>
        </div>

        <!-- Error State -->
        <div class="error-container" *ngIf="error && !loading">
            <mat-icon color="warn">error</mat-icon>
            <p>{{error}}</p>
            <button mat-raised-button color="primary" (click)="loadStatistics()">
                {{'Retry'|translate}}
            </button>
        </div>

        <!-- Chart -->
        <div class="chart-container" *ngIf="!loading && !error && chartData.length > 0">
            <canvas baseChart
                    [datasets]="chartData"
                    [labels]="chartLabels"
                    [options]="chartOptions"
                    [colors]="chartColors"
                    [legend]="true"
                    [chartType]="chartType">
            </canvas>
        </div>

        <!-- No Data -->
        <div class="no-data" *ngIf="!loading && !error && totalTrainings === 0">
            <mat-icon>info</mat-icon>
            <p>{{'No training data available for the selected period'|translate}}</p>
        </div>
    </div>

    <div mat-dialog-actions class="modal-actions">
        <button mat-raised-button color="primary" (click)="onNoClick()">
            {{'Close'|translate}}
        </button>
    </div>
</div>